module.exports = __webpack_public_path__ + "static/media/cheekSquintLeft.6079bfdd.obj";